import React, { useEffect, useState } from 'react';
import CardWIconTitleAndButton from '../../../components/card/CardWIconTitleAndButton/CardWIconTitleAndButton';
import FooterWImageAndActionButtons from '../../../components/footerwimageandactionbuttons/FooterWImageAndActionButtons';
import { HEADING } from '../../../components/heading/constants/constants';
import Heading from '../../../components/heading/Heading';
import { VEC_ICON_NAME } from '../../../components/icons/constants';
import styles from './GetFormQuantity.styles';
import commonStyles from '../OnboardingStepsCommonStyles';
import Onboarding from '../../../../libs/utility/Onboarding';
import { ONBOARDING_LOADING_STATES, ONBOARDING_ROUTES, ONBOARDING_STATES_MESSAGE_MAP } from '../constants';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey as onboardingComponentKey, setNavigateNextFromFormQuantity, setOnboardingData } from '../OnboardingSlice';
import { saveOnboardingData } from '../OnboardingSaga';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import Loadable from '../../../components/loadable/Loadable';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';

export default function GetFormQuantity() {
    const [selectedFormQuantity, setSelectedFormQuantity] = useState({});
    const navigate = useTxNavigate();
    
    const dispatch = useDispatch();
    const { loadingState, onboardingData, onboardingFormOptionsData, navigateNextFromFormQuantity } = useSelector((state) => state[onboardingComponentKey]);
    
    const numberOfForms = onboardingFormOptionsData?.FormCount ?? [];

    useEffect(() => {
        if(!selectedFormQuantity.id){
            const selectedOption = numberOfForms.find((item) =>  item.id == onboardingData.FormCount);
            setSelectedFormQuantity({...selectedOption});
        }
        dispatch(setOnboardingData({FormCount: (selectedFormQuantity.id != null) ? selectedFormQuantity.id : ""}))
    }, [selectedFormQuantity.id]);

    useEffect(() => {
        if(navigateNextFromFormQuantity){
            navigate(`/${ONBOARDING_ROUTES.ONBOARDING}/${ONBOARDING_ROUTES.ACCOUNTING_SOFTWARES}`);
            dispatch(setNavigateNextFromFormQuantity(false));
        }
    }, [navigateNextFromFormQuantity]);

    const handleNextButtonClick = () => {
        if(!onboardingData.FormCount){
            dispatch(addNotifications({ heading: "Number of forms data required", message: "To continue, please select the option that is relevant to you" }))
        }else{
            dispatch(saveOnboardingData({onboardingDataToSave: onboardingData, goToNextScreenCb: setNavigateNextFromFormQuantity, nextScreenStateValue: true}));
        }
    };

    return (
        <>
            <Loadable
                currentState={loadingState.state}
                loadingStates={[ONBOARDING_LOADING_STATES.SAVE_ONBOARDING_ACTION_LOADING]}
                messageMap={ONBOARDING_STATES_MESSAGE_MAP}
                isNewLoadable={true}
            >
                <div style={commonStyles.onboardingStepContainer}>
                    <div style={{...commonStyles.formDiv, ...styles.formDivFullWidth}}>
                        <div style={styles.stepTitleContainer}>
                            <Heading type={HEADING.H1}>How many forms do you want to file?</Heading>
                            <div>
                                <p style={styles.stepTitleDesc}>
                                    We are designed for every type of business to help you with a smooth eFile journey
                                </p>
                            </div>
                        </div>
                        <div style={styles.cardsGroupContainer}>
                            {
                                numberOfForms.map((type, idx) => {
                                    return (
                                        <div style={styles.cardContainer} onClick={() => Onboarding.handleSelectOptionClick(idx, type, setSelectedFormQuantity)}>
                                            <CardWIconTitleAndButton
                                                title={type.Label}
                                                icon={VEC_ICON_NAME.UPLOAD_FROM_COMPUTER}
                                                isHighlighted={selectedFormQuantity?.id === type.id ? true : false}
                                                customStyles={styles.individualCardStyle}
                                            />
                                        </div>
                                    )
                                })
                            } 
                        </div>
                    </div>
                    <FooterWImageAndActionButtons
                        backButton={{
                            text: "Back",
                            clickCb: () => {navigate(`/${ONBOARDING_ROUTES.ONBOARDING}/${ONBOARDING_ROUTES.COMPANY_SIZE}`)},
                        }}
                        nextButton={{
                            text: "Next",
                            clickCb: handleNextButtonClick,
                        }}
                    >
                        <span>The deadline to mail 1099s to taxpayers is usually Jan. 31.</span>
                    </FooterWImageAndActionButtons>
                </div>
            </Loadable>
        </>
    )
}